/* global Rydges, ProgressBar, lightbox, Stickyfill */
import 'select2';
import helpers from '../util/helpers';
import * as constants from '../util/constants';
import dreamBedsForm from './modules/dreamBedsForm.js';
import hotelGallery from './modules/hotelGallery.js';
import hotelRoom from './modules/hotelRoom.js';
// import loadInstagramFeeds from './modules/loadInstagramFeeds';
import searchGlobal from './modules/searchGlobal.js';
import searchAccommodations from './modules/searchAccommodations.js';
import searchLocation from './modules/searchLocation.js';
import searchOfferTypes from './modules/searchOfferTypes.js';
import searchOccasions from './modules/searchOccasions.js';
import searchGuests from './modules/searchGuests.js';
import searchEvents from './modules/searchEvents.js';
import searchRegion from './modules/searchRegion.js';
import searchBrands from './modules/searchBrands.js';
import scrollReveal from './modules/scrollReveal';

export default {
  init() {
    // JavaScript to be fired on all pages
    const page = $('html, body');
    const body = $('body');

    // Scroll distance of the body -- used for modals
    let bodyScrollDistance = 0;
    let bodyAdminBarOffset = 0;

    if (body.hasClass('admin-bar')) {
      if ($(window).width() > 783) {
        bodyAdminBarOffset = 32;
      } else {
        bodyAdminBarOffset = 46;
      }
    }

    // Lightbox Config
    if (typeof lightbox !== 'undefined') {
      lightbox.option({
        disableScrolling: true,
      });
    }

    // Header notifications
    const headerNotificationsWrapper = $('.header-notifications-wrapper');
    if (headerNotificationsWrapper.length) {
      const globalSearch = $('.search-global');
      const headerNotificationsCookie = helpers.docCookies.getItem(constants.COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY);

      if (!headerNotificationsCookie) {
        globalSearch.addClass('has-header-notifications');

        const notifClose = headerNotificationsWrapper.find('.notif-close');
        if (notifClose.length) {
          notifClose.on('click', function(e) {
            e.preventDefault();

            const cookieExpiry = notifClose.data('cookie-expiry');

            headerNotificationsWrapper.remove();
            $('.login-join-wrap').css('padding-top', '');

            helpers.docCookies.setItem(constants.COOKIE_KEY_HEADER_NOTIFICATIONS_EXPIRY, 1, cookieExpiry * 86400, '/');
            globalSearch.removeClass('has-header-notifications');
          });
        }

        // Header notifications slider
        headerNotificationsWrapper.find('.header-notifications-slider').slick({
          slidesToShow: 1,
          dots: false,
          infinite: true,
          speed: 200,
          arrows: false,
          vertical: true,
          verticalSwiping: true,
          autoplay: true,
          autoplaySpeed: headerNotificationsWrapper.data('autoplay-speed'),
        });

        /**
         * Used for setting equal heights...
         * helpers.js equal height considers row and does not work well
         * with this as this is a vertical slide and have varying position tops
         */
        const notifItems = headerNotificationsWrapper.find('.notification-item-wrapper');
        let tallestHeight = 0;

        // Get tallest height
        notifItems.each((index, item) => {
          if (tallestHeight < $(item).height()) {
            tallestHeight = $(item).height();
          }
        });

        // Set tallest height
        notifItems.each((index, item) => {
          $(item).height(tallestHeight);
        });
      } else {
        headerNotificationsWrapper.remove();
      }

      // add class to body
      body.addClass('with-header-notification');
    }

    // evtstays member dropdown
    helpers.onWindowEvents(() => {
      setAccountDropdownPosition();
    }, 1, 1, 1, 1);

    function setAccountDropdownPosition() {
      const container = $('body.transparent-header .header .container');
      if (!container) {
        return;
      }
      const offset = $('body.transparent-header .header .container').offset();
      if (offset) {
        const headerContainerOffsetRight = -(offset.left);
        $('.evt-stays-member-dropdown .dropdown-menu').css('right', headerContainerOffsetRight);
      }
    }

    // Hotel mobile menu
    const detailsTab = $('.hotel-info-col .detail-tabs');
    if (detailsTab.length) {
      let lastScroll = $(window).scrollTop();

      helpers.onWindowEvents(() => {
        // TODO: turn into helper.js func (Check if scroll passed element)
        const scrollPassed = detailsTab.offset().top + detailsTab.outerHeight();

        // Check if scroll passed element
        if ($(window).scrollTop() > scrollPassed) {
          if (!lastScroll < $(window).scrollTop()) {
            // Scrolled up
            $('.details-tab-fixed').addClass('show');
          } else {
            // Scrolled down
            $('.details-tab-fixed').removeClass('show');
          }
        } else {
          $('.details-tab-fixed').removeClass('show');
        }

        lastScroll = $(window).scrollTop();
      }, 0, 1, 0, 1);
    }

    // Open Hotel Mobile Booking Modal
    const showHotelMobileBookingBtn = $('.show-hotel-mobile-booking-btn');
    if (showHotelMobileBookingBtn.length) {
      showHotelMobileBookingBtn.on('click', function() {
        $('.hotel-mobile-booking-modal').addClass('show');

        // Add top bodyScroll
        bodyScrollDistance = $(window).scrollTop();
        body.css('top', (bodyScrollDistance - bodyAdminBarOffset) * -1);

        body.addClass('modal-open');
      });

      $(document).on('click', function(event) {
        if (body.hasClass('modal-open')) {
          if ($(event.target).hasClass('hotel-mobile-booking-modal')) {
            $('.hotel-mobile-booking-modal').removeClass('show');
            body.removeClass('modal-open');

            // Remove top bodyScroll
            body.css('top', '');
            $(window).scrollTop(bodyScrollDistance);
          }
        }
      });
    }

    // select2
    const selects = $('select.select2');
    if (selects.length) {
      selects.each(function() {
        const _this = $(this);
        const allowClear = _this.data('allow-clear');
        const dropdownCssClass = _this.data('dropdown-css-class');
        const formatOptionLabel = _this.data('format-option-label');
        const placeholder = _this.data('placeholder');
        const args = {};

        if (_this.hasClass('no-search-box')) {
          args['minimumResultsForSearch'] = -1;
        } else if (_this.hasClass('infinity')) {
          args['minimumResultsForSearch'] = Infinity;
        }

        if (_this.attr('name') === 'dynamicIndustry') {
          args['placeholder'] = 'Select';
          args['minimumResultsForSearch'] = -1;
        } else if (_this.attr('name') === 'dynamicHotelName[]') {
          args['placeholder'] = 'Select hotel(s)';
        } else if (_this.attr('name') === 'dynamicAdults') {
          _this.find('option').each(function() {
            if ($(this).val() === '2') {
              $(this).prop('selected', true);
            }
          });
        } else if (_this.attr('name') === 'dynamicChildren') {
          _this.find('option').each(function() {
            if ($(this).val() === '1') {
              $(this).prop('selected', true);
            }
          });
        }

        if (allowClear) {
          args['allowClear'] = allowClear;
        }

        if (dropdownCssClass) {
          args['dropdownCssClass'] = dropdownCssClass;
        }

        if (formatOptionLabel) {
          args['templateResult'] = function(state) {
            if (!state.id) {
              return state.text;
            }

            return $(`<span class="${$(state.element).data('class')}">${state.text}</span>`);
          };
        }

        if (placeholder) {
          args['placeholder'] = placeholder;
        }

        const select2Init = _this.select2(args);

        if (allowClear) {
          // Prevent opening the dropdown on clear button click
          select2Init.on('select2:unselecting', function () {
            const thisSelect2 = $(this);

            thisSelect2.data('unselecting', true);
          }).on('select2:opening', function (e) {
            const thisSelect2 = $(this);

            if (thisSelect2.data('unselecting')) {
              thisSelect2.removeData('unselecting');

              e.preventDefault();
            }
          });
        }
      });

      // Open select2 dropdown on focus
      $(document).on('focus', '.select2', function (e) {
        if (e.originalEvent) {
          const _this = $(this);

          if (_this.siblings('select[multiple]').length === 0 && !_this.hasClass('select2-container--focus') && !_this.hasClass('select2-container--open')) {
            _this.siblings('select:enabled').select2('open');
          }
        }
      });
    }

    // Custom Dropdown for Mobile booking
    let rsdDropdown = $('.rsd-dropdown');
    if (rsdDropdown.length) {
      rsdDropdown.each(function() {
        let thisDropdown = $(this);
        let dropdownId = thisDropdown.data('rsd-dropdown');
        let disableForm = false;
        let hotelBookingContainer = thisDropdown.closest('.hotel-booking-form-container, .hotel-booking-fixed-lg');

        if (thisDropdown.data('rsd-disable-form')) {
          disableForm = thisDropdown.data('rsd-disable-form');
        }

        thisDropdown.on('click', function() {
          $('#' + dropdownId).toggle();

          if (disableForm) {
            hotelBookingContainer.toggleClass('disable');
            if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
              body.toggleClass('bookwidget-guests');
            }
          }
        });

        if (hotelBookingContainer.length) {
          hotelBookingContainer.find('.apply-btn').on('click', function() {
            $('#' + dropdownId).hide();
            hotelBookingContainer.removeClass('disable');

            if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
              body.removeClass('bookwidget-guests');
            }
          });

          // hide when clicked outside dropdown
          $(document).on('click', function(event) {
            if (
              !hotelBookingContainer.is(event.target) && hotelBookingContainer.has(event.target).length === 0
            ) {
              $('#' + dropdownId).hide();
              hotelBookingContainer.removeClass('disable');

              if (hotelBookingContainer.hasClass('hotel-booking-fixed-lg')) {
                body.removeClass('bookwidget-guests');
              }
            }
          });
        }

      });
    }

    // Mobile Menu
    let mobileMenu = $('.mobile-menu');
    if (mobileMenu.length) {
      $(document).on('click', '.mobile-menu-toggle', function() {
        body.toggleClass('mobile-menu-on');
        body.removeClass('search-mode login-signup-mode');

        if (body.hasClass('mobile-menu-on')) {
          helpers.stopBodyScrolling(true);
        } else {
          helpers.stopBodyScrolling(false);
        }
      });
    }

    // Promotion Grid
    const mobilePromotionCategoriesSlider = $('.section-common-promo-categories-grid .slider');
    if (mobilePromotionCategoriesSlider.length) {
      mobilePromotionCategoriesSlider.slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        arrows: false,
      });
    }

    const promoCategoriesGrid = $('.section-common-promo-categories-grid .grid-container');
    if (promoCategoriesGrid.length) {
      const items = promoCategoriesGrid.find('.item');
      if (items.length) {
        items.each((index, elem) => {
          const collapse = $(elem).find('.collapse');

          $(elem).mouseenter(() => {
            collapse.collapse('show');
          });

          $(elem).mouseleave(() => {
            collapse.collapse('hide');
          });
        });
      }
    }

    // Offers and Promotion slider
    const offerAndPromotion = $('.section-offer-and-promotion .slider');
    if (offerAndPromotion.length) {
      offerAndPromotion.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        variableWidth: true,
        swipeToSlide: true,
        prevArrow: $('.section-offer-and-promotion .prev'),
        nextArrow: $('.section-offer-and-promotion .next'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    // Enquire Form No Label Fill
    let borderFillupInput = '.border-fillup input';
    if ($(borderFillupInput).length) {
      $(document).on('keyup keydown', borderFillupInput, function() {
        let underline = $(this).parent().find('.underlined-input');
        underline.text($(this).val());
      });
    }

    // Floating label inputs
    const floatingLabel = $('.floating-label');
    if (floatingLabel.length) {
      floatingLabel.each(function() {
        const _this = $(this);
        const input = _this.find('input, textarea');
        const floatedClass ='floated';

        input.bind('check_val', function () {
          if (input.val() !== '') {
            _this.addClass(floatedClass);
          } else {
            _this.removeClass(floatedClass);
          }
        }).on('focus', function () {
          _this.addClass(floatedClass);
        }).on('blur', function () {
          input.trigger('check_val');
        }).trigger('check_val');
      });
    }

    // global search
    let globalSearch = '.global-search-form input.search-input';
    if ($(globalSearch).length) {
      $(document).on('click', '.global-search-btn', function() {
        body.toggleClass('search-mode');
        body.removeClass('login-signup-mode mobile-menu-on');
        $('.global-search-input').focus();

        if( body.hasClass('search-mode') ) {
          helpers.stopBodyScrolling(true);
        } else {
          helpers.stopBodyScrolling(false);
        }

        return false;
      });
      $(document).on('keyup keydown', globalSearch, function() {
        $('.global-search-form .underlined-input').text($(this).val());
      });
      $(document).on('mousedown', globalSearch, function(e) {
        // Use 'mousedown' event to bypass keyboard ios safari slide up
        e.preventDefault();

        if (body.hasClass('mobile-menu-on')) { //for mobile only
          body.addClass('expand-msearch');

          let upperSearch = $('.search-cancel-wrap').outerHeight() + $('.search-form-row').outerHeight();
          $('.search-results-row').height($(window).height() - upperSearch);

          $('.overlay-content .mobile-menu').addClass('search-open');
          $('.overlay-content').addClass('search-open');
        }

        // Then focus the input
        $(this).focus();
      });
      $(document).on('click', '.search-cancel', function() {
        body.removeClass('expand-msearch');
        $(globalSearch).val('');
        $('.search-results-row').css('height', '');
        $('.overlay-content .mobile-menu').removeClass('search-open');
        $('.overlay-content').removeClass('search-open');

        return false;
      });
      // Close when click outside bounding container
      let globalSearchContainer = $('.search-global .container');
      $('.overlay-wrap').on('click', function(e) {
        if (body.hasClass('search-mode')) {
          if (!globalSearchContainer.is(e.target) && globalSearchContainer.has(e.target).length === 0) {
            body.removeClass('search-mode');
            helpers.stopBodyScrolling(false);
            return false;
          }
        }
      });
      $(document).on('keydown', function(e) {
        if (body.hasClass('search-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('search-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });
    }

    let auth0Settings = {};

    if (window.EVT_Stays_Membership) {
      auth0Settings = window.EVT_Stays_Membership.auth0Settings || {};
    }

    // Login / Join
    let loginJoin = $('.login-join-wrap');
    if (loginJoin.length) {
      $(document).on('click', '.login-join-trigger, .login-join-close, .join-trigger, .trigger-evtstays-login, .trigger-pgr-login, .trigger-evtstays-join, .trigger-pgr-join', function(e) {
        e.preventDefault();
        const _this = $(this);

        if (auth0Settings.isEnabled) {
          if (_this.is('.trigger-evtstays-join, .trigger-pgr-join, .join-trigger')) {
            window.EVT_Stays_Membership.auth0Settings.join();
          } else {
            window.EVT_Stays_Membership.auth0Settings.login();
          }

          return false;
        }

        // Add padding-top if has headerNotif
        if (headerNotificationsWrapper.length) {
          if ($(window).scrollTop() < headerNotificationsWrapper.height()) {
            const paddingTopOffset = headerNotificationsWrapper.height() - $(window).scrollTop() + 15;
            $('.login-join-wrap').css('padding-top', paddingTopOffset + 'px');
          } else {
            $('.login-join-wrap').css('padding-top', '');
          }
        }

        if ($(this).hasClass('login-trigger')) {
          loginJoin.removeClass('switch');
        }

        // Is showing
        if( !body.hasClass('login-signup-mode') ) {
          bodyScrollDistance = $(window).scrollTop();
          body.css('top', (bodyScrollDistance - bodyAdminBarOffset) * -1);
        }

        body.toggleClass('login-signup-mode');
        body.removeClass('search-mode mobile-menu-on');

        // Has hidden
        if (!body.hasClass('login-signup-mode')) {
          body.css('top', '');
          $(window).scrollTop(bodyScrollDistance);
        }

        return false;
      });

      $(document).on('click', '.join-trigger', function(e) {
        e.preventDefault();
        loginJoin.addClass('switch');
        return false;
      });

      $(document).on('click', '.trigger-evtstays-login, .trigger-pgr-login', function(e) {
        e.preventDefault();
        loginJoin.removeClass('switch');
        return false;
      });

      $(document).on('click', '.trigger-evtstays-join, .trigger-pgr-join', function(e) {
        e.preventDefault();
        loginJoin.addClass('switch');
        return false;
      });

      $(document).on('click', '.toggle-cards', function(e) {
        e.preventDefault();
        loginJoin.toggleClass('switch');
        return false;
      });

      $(document).on('click', function(e) {
        e.stopPropagation();
        if (body.hasClass('login-signup-mode')) {
          if ($(e.target).hasClass('overlay-wrap')) {
            body.removeClass('login-signup-mode');

            // Remove bodyScroll top
            body.css('top', '');
            $(window).scrollTop(bodyScrollDistance);
          }
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('login-signup-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('login-signup-mode');

            // Remove bodyScroll top
            body.css('top', '');
            $(window).scrollTop(bodyScrollDistance);
          }
        }
      });

      const joinModalParam = helpers.getParameterByName('join-modal');
      if (joinModalParam != null && joinModalParam.length && joinModalParam.toLowerCase() === 'true') {
        body.addClass('login-signup-mode');
        body.removeClass('search-mode mobile-menu-on');
        loginJoin.addClass('switch');
        helpers.stopBodyScrolling(true);
      }
    }

    const heroSliderBg = $('.section-common-hero-slider .slider-bg');
    const heroSliderContent = $('.section-common-hero-slider .slider-content');
    if (heroSliderBg.length) {
      // hero slider circle loader
      let circleLoader = $('.section-common-hero-slider .circle-loader');
      if (circleLoader.length) {
        let bar = new ProgressBar.Circle('.circle-loader', {
          strokeWidth: 12,
          easing: 'easeInOut',
          duration: 500,
          color: '#871c3c',
          trailColor: '#ccc',
          trailWidth: 9,
          svgStyle: null,
        });
        bar.animate(1);

        heroSliderBg.on('init', function() {
          circleLoader.fadeOut();
        });
      }

      // common hero slider
      heroSliderBg.slick({
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        arrows: false,
        cssEase: 'ease-in-out',
        asNavFor: heroSliderContent,
      });

      heroSliderContent.slick({
        dots: false,
        infinite: true,
        fade: true,
        arrows: true,
        appendArrows: '.section-common-hero-slider .slider-nav',
        asNavFor: heroSliderBg,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              fade: false,
              centerPadding: '20px',
            },
          },
        ],
      });
    }

    // common promo slider
    const promoSlider = $('.section-common-promo-sliders .slider');
    if (promoSlider.length) {
      promoSlider.on('init', function() {
        helpers.equalHeightElements('.slider .equal-height');
      });

      promoSlider.slick({
        dots: false,
        infinite: true,
        arrows: true,
        appendArrows: '.section-common-promo-sliders .slide-nav',
        fade: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              fade: false,
            },
          },
        ],
      }).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        $('.section-common-promo-sliders').find('.slide-index').html(nextSlide + 1);
      });
    }

    // common promo block slider
    const promoBlockSlider = $('.section-common-promo-blocks .block-slider');
    if (promoBlockSlider.length) {
      promoBlockSlider.slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 991,
            settings: 'unslick',
          },
        ],
      });
    }

    // common cpt slider
    const cptSlider = $('.section-common-cpt-sliders .slider');
    if (cptSlider.length) {
      cptSlider.on('init', function() {
        cptSlider.nextAll('.slider-skeleton:first').hide();
      });

      cptSlider.slick({
        dots: false,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
      });
    }

    const commonGallery = $('.section-hotel-common-gallery .slider');
    if (commonGallery.length) {
      commonGallery.slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
      });
    }

    const cptVenueSlider = $('.section-hotel-venue-slider .slider');
    if (cptVenueSlider.length) {
      cptVenueSlider.on('init', function() {
        helpers.equalHeightElements('.slider .equal-height');
      });

      cptVenueSlider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        mobileFirst: true,
        prevArrow: $('.section-hotel-venue-slider .prev'),
        nextArrow: $('.section-hotel-venue-slider .next'),
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    }

    const nearbyHotelsSlider = $('.nearby-hotels-slider .slider');
    if (nearbyHotelsSlider.length) {
      nearbyHotelsSlider.on('init', function() {
        helpers.equalHeightElements('.nearby-hotels-slider .equal-height');
      });

      const slickResponsive = [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
      ];

      if (nearbyHotelsSlider.hasClass('no-booking-widget')) {
        slickResponsive.push({
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          },
        });
      }

      nearbyHotelsSlider.slick({
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        appendArrows: '.nearby-hotels-slider .slide-nav',
        mobileFirst: true,
        responsive: slickResponsive,
      });
    }

    // Expandable content
    let expandable = $('.expandable-content');
    if (expandable.length) {
      expandable.each(function() {
        let thisExpandable = $(this);
        let thisExpandableHeight = thisExpandable.data('height');
        let thisExpandableToggle = thisExpandable.next('.expandable-toggle');

        if ($('.content-inner').height() < thisExpandableHeight) {
          thisExpandableToggle.hide();
          thisExpandable.css('height', 'auto');
          thisExpandable.addClass('expanded');
        }
        thisExpandableToggle.click(function(e) {
          e.preventDefault();
          let delay = 200;
          if (thisExpandable.height() === thisExpandableHeight) {
            helpers.autoHeightAnimate(thisExpandable, delay);
            thisExpandable.addClass('expanded');
            $(this).find('span').html(thisExpandableToggle.data('less'));
          } else {
            thisExpandable.stop().animate({height: thisExpandableHeight}, delay);
            thisExpandable.removeClass('expanded');
            $(this).find('span').html(thisExpandableToggle.data('more'));
          }
          thisExpandable.find('.overlay').toggle();
          setTimeout(function() {
            page.trigger('expandableClick');
          }, delay);
        });
      });
    }

    // Enquire form collapse
    const collapseToggles = $('.js-toggle-collapse');
    if( collapseToggles.length ) {

      collapseToggles.each(function() {

        $(this).on('click', function() {
          let collapser = $(this);
          let toCollapse = collapser.data('target');

          $(toCollapse).on('show.bs.collapse', function() {
            collapser.removeClass('collapsed');
          });

          $(toCollapse).on('hide.bs.collapse', function() {
            collapser.addClass('collapsed');
          });

          $(toCollapse).collapse('toggle');
        });
      });
    }

    const enquireFormPopupBtn = $('.enquire-form-popup-btn');
    if (enquireFormPopupBtn.length) {
      const enquireWrapper = $('.hotel-event-enquire-container .hotel-enquire-wrapper');

      helpers.onWindowEvents(() => {
        const currentScroll = $(window).scrollTop();
        const enquireWrapperBottom = enquireWrapper.position().top + enquireWrapper.outerHeight(true);

        if (currentScroll > (enquireWrapperBottom + 250)) {
          enquireFormPopupBtn.addClass('popup');
        } else {
          enquireFormPopupBtn.removeClass('popup');
        }
      }, 1, 1, 0, 1);

      enquireFormPopupBtn.on('click', function(e) {
        e.preventDefault();

        enquireWrapper.goToElement(undefined, -50);
      });
    }

    const enquireFormCollapse = $('#enquire-form-collapse');
    if (enquireFormCollapse.length) {
      enquireFormCollapse.on('show.bs.collapse', function () {
        // Add bodyScroll top
        bodyScrollDistance = $(window).scrollTop();
        body.css('top', (bodyScrollDistance - bodyAdminBarOffset) * -1);

        body.addClass('enquire-form-open');
      });

      enquireFormCollapse.on('hide.bs.collapse', function () {
        body.removeClass('enquire-form-open');

        // Remove bodyScroll top
        body.css('top', '');
        $(window).scrollTop(bodyScrollDistance);
      });
    }

    // Sticky-top Polyfill for ie11
    const stickyElements = $('.sticky-top');
    if( stickyElements.length && helpers.IsIEBrowser() ) {
      Stickyfill.add(stickyElements);
    }

    // CF7 forms
    const contactForm = $('form.wpcf7-form');
    if (contactForm.length) {
      $(document).on('wpcf7mailsent', function() {
        // Clear select2 if submit is success
        const selects = contactForm.find('select.select2');
        const noticeWrapper = contactForm.find('.booking-enquiry-contact-form-card .notice-wrapper');

        selects.each(function() {
          const _this = $(this);

          _this.val(null).trigger('change');

          if (_this.attr('name') === 'dynamicAdults') {
            _this.val('2').trigger('change');
          } else if (_this.attr('name') === 'dynamicChildren') {
            _this.val('1').trigger('change');
          }
        });

        noticeWrapper.html('');
      });
    }
  },
  finalize() {
    const body = $('body');

    // JavaScript to be fired on all pages, after page specific JS is fired
    // Balance elements
    helpers.onWindowEvents(() => {
      helpers.equalHeightElements($('.balance-elements'), false, 30);
    }, 1, 1, 1, 0);

    // scroll to element if url has a hash
    helpers.onWindowEvents(() => {
      if (location.hash.length !== 0) {
        const hash = location.hash;

        try {
          if ($(hash).length) {
            $(hash).goToElement(undefined, -73, false);
          }
        } catch (e) {
          return false;
        }
      }
    }, 0, 1, 0, 0);

    // Scroll hotel nav to active menu item
    helpers.onWindowEvents(() => {
      const detailTabs = $('.detail-tabs');
      if (detailTabs.length) {
        detailTabs.each(function() {
          const tab = $(this);
          const menuItems = tab.find('.nav > li');
          let leftToScroll = 0;

          menuItems.each(function() {
            if ($(this).hasClass('current_page_item') || $(this).hasClass('current_page_ancestor')) {
              return false;
            }

            leftToScroll += $(this).outerWidth(true);
          });

          tab.scrollLeft(leftToScroll);
        });
      }
    }, 1, 0, 0, 0);

    $(document).on(constants.EVENT_BALANCE_ELEMENTS, () => {
      helpers.equalHeightElements($('.balance-elements'), false, 30);
    });

    // Most search slider
    const mostSearchSlider = $('.section-most-searched .slider');
    if (mostSearchSlider.length) {
      mostSearchSlider.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        variableWidth: true,
        swipeToSlide: true,
        prevArrow: $('.section-most-searched .prev'),
        nextArrow: $('.section-most-searched .next'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    // Footer Hotels Slider
    const footerHotels = $('.footer-hotels');
    const footerHotelSlider = footerHotels.find('.slider');
    if (footerHotelSlider.length) {
      footerHotelSlider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        slidesToShow: 3,
        appendArrows: footerHotels.find('.slider-nav'),
        centerMode: true,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }

    // Hotel gallery slider
    const loadHotelGallerySlider = () => {
      const hotelGallery = $('.section-hotel-hp-gallery .slider');
      if (hotelGallery.length) {
        hotelGallery.each(function() {
          const _this = $(this);

          if (!_this.hasClass('slick-initialized')) {
            _this.on('init', function() {
              _this.nextAll('.slider-skeleton:first').hide();
            });

            _this.slick({
              dots: false,
              arrows: true,
              appendArrows: _this.closest('.section-hotel-hp-gallery').find('.slider-nav'),
              infinite: false,
              speed: 300,
              slidesToShow: 1,
            });
          }
        });
      }
    };

    loadHotelGallerySlider();
    $(document).on(constants.EVENT_HOTEL_ROOM_MODAL_LOADED, loadHotelGallerySlider);

    // if ('undefined' !== typeof document.referrer && document.referrer === Rydges['homeUrl']) {
    //   $(document).on('click', '.back-to-hotel', function(e) {
    //     e.preventDefault();
    //
    //     history.back();
    //   });
    // }

    // Slick room sliders
    const roomSlider = $('.section-hotel-hp-detail-booking .rooms-slider');
    if (roomSlider.length) {
      roomSlider.on('init', function() {
        helpers.equalHeightElements('.rooms-slider .equal-height');
      });

      roomSlider.slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 991,
            settings: 'unslick',
          },
        ],
      });
    }

    const singleRoomSlider = $('.section-hotel-hp-detail-booking .single-room-wrapper .slider');
    if (singleRoomSlider.length) {
      singleRoomSlider.each(function() {
        let _this = $(this);

        _this.on('init', function() {
          _this.nextAll('.slider-skeleton:first').hide();
        });

        _this.slick({
          dots: false,
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          swipe: false,
          mobileFirst: true,
          prevArrow: _this.parent('.preview-images').find('.prev'),
          nextArrow: _this.parent('.preview-images').find('.next'),
        });
      });
    }

    const hotelRoomSubmit = $('.hotel-room-submit');
    if (hotelRoomSubmit.length) {
      hotelRoomSubmit.each(function() {
        const _this = $(this);

        _this.on('click', function(e) {
          e.stopPropagation();

          const roomCode = _this.data('room-code');
          if (roomCode) {
            $('.hotel-booking-form').find('[name="roomCode"]').val(roomCode);
          }

          if (window.innerWidth >= 992) {
            // Desktop
            $('.hotel-booking-form-container.sidebar-wrapper').goToElement(undefined, -50);
            $('.booking-daterange-picker').first().data('daterangepicker').show();
          } else if (window.innerWidth < 992) {
            // Mobile
            $('.hotel-mobile-booking-modal').addClass('show');
            body.addClass('modal-open');
          }

          return false;
        });
      });
    }

    // Global / Hotel enquire form modal
    const enquireForm = $('.global-event-enquire-form, .hotel-event-enquire-form');
    if (enquireForm.length) {
      $(document).on('click', '.enquire-form-trigger, .enquire-form-close, .meetings-enquire-form-trigger, .weddings-enquire-form-trigger', function() {
        body.toggleClass('enquire-form-mode');
        return false;
      });

      $(document).on('click', '.meetings-enquire-form-trigger, .weddings-enquire-form-trigger', function() {
        const formType = $(this).hasClass('meetings-enquire-form-trigger') ? 'meetings' : 'weddings';

        enquireForm.find('.offer-enquire-form').hide();
        enquireForm.find(`#${formType}-enquire-form`).show();
      });

      $(document).on('click', function(e) {
        e.stopPropagation();
        if (body.hasClass('enquire-form-mode')) {
          if ($(e.target).hasClass('overlay-wrap')) {
            body.removeClass('enquire-form-mode');
          }
        }
      });

      if (window.location.hash === '#enquire-form-trigger') {
        body.addClass('enquire-form-mode');
      }
    }

    // Load instagram feeds
    // loadInstagramFeeds();

    // Dream Beds Contact Form
    dreamBedsForm();

    // Search Global
    searchGlobal();

    // Search Accommodations
    searchAccommodations();

    // Search Location
    searchLocation();

    // Search offer types
    searchOfferTypes();

    // Search occasions
    searchOccasions();

    // Search guests
    searchGuests();

    // Search event types
    searchEvents();

    // Search regions
    searchRegion();

    // Search brands
    searchBrands();

    // Hotel gallery
    hotelGallery();

    // Hotel room
    hotelRoom();

    // Global enquire form
    let globalEnquireWrapper = $('.global-enquire-wrapper');
    if (globalEnquireWrapper.length) {
      globalEnquireWrapper.each(function() {
        const thisEnquire = $(this);

        let stepOneForm = $('#form-collapse-1');
        let stepTwoForm = $('#form-collapse-2');
        let pageNumber = thisEnquire.find('.page-number span');
        let continueBtn = thisEnquire.find('.continue-btn');
        let submitBtn = thisEnquire.find('.submit-btn');
        let backBtn = thisEnquire.find('.back-btn');

        thisEnquire.find('.nav-tabs .nav-item[data-toggle="tab"]').on('shown.bs.tab', function(e) {
          let targetTabIndex = parseInt(thisEnquire.find('.nav-tabs .nav-item[data-toggle="tab"]').index(e.target)) + 1;

          pageNumber.text('0' + targetTabIndex);
          continueBtn.toggleClass('d-none');
          submitBtn.toggleClass('d-none');
          backBtn.toggleClass('d-none');
        });

        $(document).on('wpcf7submit', function() {
          continueBtn.removeClass('disabled');
          submitBtn.removeClass('disabled');
        });

        $(document).on('wpcf7invalid', function() {
          continueBtn.removeClass('disabled');
          submitBtn.removeClass('disabled');

          let requiredSelectField = $('select.wpcf7-validates-as-required');
          if (requiredSelectField.length) {
            requiredSelectField.each(function() {
              let _this = $(this);

              if (_this.val() === '') {
                _this.addClass('wpcf7-not-valid');
              } else {
                _this.removeClass('wpcf7-not-valid');
              }
            });
          }
        });

        continueBtn.keypress(function(e) {
          if (e.key === 'Enter') {
            continueBtn.trigger('click');
          }
        });

        continueBtn.click(function(e) {
          e.preventDefault();

          // Disable form buttons
          continueBtn.addClass('disabled');
          submitBtn.addClass('disabled');

          // Step one form validations
          thisEnquire.find('input.wpcf7-submit[type="submit"]').trigger('click');

          $(document).on('wpcf7invalid', function() {
            setTimeout(function() {
              // check if there's some error on step one form
              let formOneInvalidFields = stepOneForm.find('.wpcf7-not-valid');
              if (formOneInvalidFields.length === 0) {
                thisEnquire.find('.nav-tabs .nav-item[href="#form-collapse-2"]').removeClass('disabled').trigger('click');
              }

              // check if there's some error on step two form
              let formTwoInvalidFields = stepTwoForm.find('.wpcf7-not-valid');
              if (formTwoInvalidFields.length) {
                formTwoInvalidFields.each(function() {
                  let _this = $(this);

                  _this.removeClass('wpcf7-not-valid');
                });
              }
            }, 5);
          });
        });

        submitBtn.keypress(function(e) {
          if (e.key === 'Enter') {
            submitBtn.trigger('click');
          }
        });

        submitBtn.click(function(e) {
          e.preventDefault();

          // Disable form buttons
          continueBtn.addClass('disabled');
          submitBtn.addClass('disabled');

          // Step two form validations
          thisEnquire.find('input.wpcf7-submit[type="submit"]').trigger('click');

          $(document).on('wpcf7invalid', function() {
            setTimeout(function() {
              // check if there's some error on step one form
              let formOneInvalidFields = stepOneForm.find('.wpcf7-not-valid');
              if (formOneInvalidFields.length) {
                thisEnquire.find('.nav-tabs .nav-item[href="#form-collapse-1"]').trigger('click');
              }

              // check if there's some error on step two form
              let formTwoRequiredFields = stepTwoForm.find('.wpcf7-validates-as-required');
              if (formTwoRequiredFields.length) {
                formTwoRequiredFields.each(function() {
                  let _this = $(this);

                  if (_this.val() === '') {
                    _this.addClass('wpcf7-not-valid');
                  } else {
                    _this.removeClass('wpcf7-not-valid');
                  }
                });
              }
            }, 5);
          });
        });

        backBtn.click(function(e) {
          e.preventDefault();

          thisEnquire.find('.nav-tabs .nav-item[href="#form-collapse-1"]').trigger('click');
        });
      });
    }

    // Hotel enquire form
    let hotelEnquireWrapper = $('.hotel-enquire-wrapper');
    if (hotelEnquireWrapper.length) {
      hotelEnquireWrapper.each(function() {
        const thisEnquire = $(this);

        let stepOneForm = $('#form-collapse-1');
        let stepTwoForm = $('#form-collapse-2');
        let pageNumber = thisEnquire.find('.page-number strong');
        let continueBtn = thisEnquire.find('.continue-btn');
        let submitBtn = thisEnquire.find('.submit-btn');

        thisEnquire.find('.nav-tabs .nav-item[data-toggle="tab"]').on('shown.bs.tab', function(e) {
          let targetTabIndex = parseInt(thisEnquire.find('.nav-tabs .nav-item[data-toggle="tab"]').index(e.target)) + 1;

          pageNumber.text('0' + targetTabIndex);
          continueBtn.toggleClass('d-none');
          submitBtn.toggleClass('d-none');
        });

        $(document).on('wpcf7submit', function() {
          continueBtn.removeClass('disabled');
          submitBtn.removeClass('disabled');
        });

        $(document).on('wpcf7invalid', function() {
          continueBtn.removeClass('disabled');
          submitBtn.removeClass('disabled');

          let requiredSelectField = $('select.wpcf7-validates-as-required');
          if (requiredSelectField.length) {
            requiredSelectField.each(function() {
              let _this = $(this);

              if (_this.val() === '') {
                _this.addClass('wpcf7-not-valid');
              } else {
                _this.removeClass('wpcf7-not-valid');
              }
            });
          }
        });

        continueBtn.keypress(function(e) {
          if (e.key === 'Enter') {
            continueBtn.trigger('click');
          }
        });

        continueBtn.click(function(e) {
          e.preventDefault();

          // Disable form buttons
          continueBtn.addClass('disabled');
          submitBtn.addClass('disabled');

          // Step one form validations
          thisEnquire.find('input.wpcf7-submit[type="submit"]').trigger('click');

          $(document).on('wpcf7invalid', function() {
            setTimeout(function() {
              // check if there's some error on step one form
              let formOneInvalidFields = stepOneForm.find('.wpcf7-not-valid');
              if (formOneInvalidFields.length === 0) {
                thisEnquire.find('.nav-tabs .nav-item[href="#form-collapse-2"]').removeClass('disabled').trigger('click');
              }

              // check if there's some error on step two form
              let formTwoInvalidFields = stepTwoForm.find('.wpcf7-not-valid');
              if (formTwoInvalidFields.length) {
                formTwoInvalidFields.each(function() {
                  let _this = $(this);

                  _this.removeClass('wpcf7-not-valid');
                });
              }
            }, 5);
          });
        });

        submitBtn.keypress(function(e) {
          if (e.key === 'Enter') {
            submitBtn.trigger('click');
          }
        });

        submitBtn.click(function(e) {
          e.preventDefault();

          // Disable form buttons
          continueBtn.addClass('disabled');
          submitBtn.addClass('disabled');

          // Step two form validations
          thisEnquire.find('input.wpcf7-submit[type="submit"]').trigger('click');

          $(document).on('wpcf7invalid', function() {
            setTimeout(function() {
              // check if there's some error on step one form
              let formOneInvalidFields = stepOneForm.find('.wpcf7-not-valid');
              if (formOneInvalidFields.length) {
                thisEnquire.find('.nav-tabs .nav-item[href="#form-collapse-1"]').trigger('click');
              }

              // check if there's some error on step two form
              let formTwoRequiredFields = stepTwoForm.find('.wpcf7-validates-as-required');
              if (formTwoRequiredFields.length) {
                formTwoRequiredFields.each(function() {
                  let _this = $(this);

                  if (_this.val() === '') {
                    _this.addClass('wpcf7-not-valid');
                  } else {
                    _this.removeClass('wpcf7-not-valid');
                  }
                });
              }
            }, 5);
          });
        });
      });
    }

    // Eat & drink reservation form
    const reservationForm = $('.hotel-dining-reservation-form');
    if (reservationForm.length) {
      $(document).on('click', '.reservation-form-trigger, .reservation-form-close', function(e) {
        e.preventDefault();
        body.toggleClass('reservation-form-mode');
        return false;
      });

      $(document).on('click', function(e) {
        e.stopPropagation();
        if (body.hasClass('reservation-form-mode')) {
          if ($(e.target).hasClass('overlay-wrap')) {
            body.removeClass('reservation-form-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });

      $(document).on('wpcf7invalid', function() {
        let requiredSelectField = reservationForm.find('select.wpcf7-validates-as-required');
        if (requiredSelectField.length) {
          requiredSelectField.each(function() {
            let _this = $(this);

            if (_this.val() === '') {
              _this.addClass('wpcf7-not-valid');
            } else {
              _this.removeClass('wpcf7-not-valid');
            }
          });
        }
      });

      $(document).on('keydown', function(e) {
        if (body.hasClass('reservation-form-mode')) {
          if (e.key === 'Escape') {
            body.removeClass('reservation-form-mode');
            helpers.stopBodyScrolling(false);
          }
        }
      });
    }

    // Gift card form
    let giftCardSection = $('.gift-card-form, .wp-block-cgb-gift-card-block');
    if (giftCardSection.length) {
      let message = giftCardSection.find('.message');
      let checkBalanceForm = giftCardSection.find('#check-balance-form');
      let giftCardCode = giftCardSection.find('#giftcard-code');

      giftCardCode.on('input propertychange paste', function() {
        message.find('.alert').fadeTo(300, 0, function() {
          $(this).remove();
        });
      });

      checkBalanceForm.submit(function(e) {
        e.preventDefault();

        let giftCardCodeVal = giftCardCode.val();
        let isNumber = /^\d+$/.test(giftCardCodeVal);
        let errorMesssage = '';
        if (giftCardCodeVal === '') {
          errorMesssage = 'Please enter your gift card number.';
        } else if (!isNumber) {
          errorMesssage = 'Gift card number must be digits only.';
        } else if (giftCardCodeVal.length !== 11 && giftCardCodeVal.length !== 16 && giftCardCodeVal.length !== 18) {
          errorMesssage = 'Gift card number must be 11, 16 or 18 digits long.';
        }

        if (errorMesssage === '') {
          const button = checkBalanceForm.find('button');

          button.prop('disabled', true);
          checkBalanceForm.append('<span class="spinner-loader ml-3"></span>');

          let url = constants.EVT_STAYS_MEMBERSHIP_REST__GIFTCARDS_BASE_EVT_STAYS + '?giftcard_code=' + giftCardCodeVal;

          $.getJSON(url,
            function(dt) {
              if (dt['@attributes']['success'] === '1') {
                $('#floatingBarsG').hide();

                const points = dt['productInfo']['pointsBalance'];
                const productName = dt['productInfo']['productName'];
                const match = productName.match(/\(([^)]+)\)/);
                let currency = '';

                if (match) {
                  currency = match[1];
                }

                message.html(helpers.getAlertHtml(`Balance: ${points} ${currency}`, 'success'));
              } else if (dt['@attributes']['success'] === '0') {
                message.html(helpers.getAlertHtml(dt['error'], 'danger'));
              } else {
                message.html(helpers.getAlertHtml('Error', 'danger'));
              }

              button.prop('disabled', false);
              checkBalanceForm.find('.spinner-loader').remove();
            }
          );
        } else {
          message.html(helpers.getAlertHtml(errorMesssage, 'warning'));
        }
      });
    }

    // Scroll Reveal https://scrollrevealjs.org/api/reveal.html
    scrollReveal();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js